import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { Promise } from "rsvp"

export default class SharedDayRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return new Promise((resolve, _reject) => {
      get(this, "store")
        .find("planbook", params.planbook_id)
        .then((planbook) => {
          // let coursePromises = _.map(planbook.relationships.courses.data, hash => get(this, 'store').find('course', hash.id))
          // Ember.RSVP.allSettled(coursePromises)
          // ).then(array => {
          //
          // })

          return get(this, "store")
            .find("rotation-calendar", planbook.relationships.rotationCalendar.data.id)
            .then((rotationCalendar) => {
              resolve({
                planbook,
                rotationCalendar,
                dateString: params.date_string,
              })
            })
        })
    })
  }
}
